var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_879_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9027 10.5397C13.9027 9.00128 14.6351 7.87862 16.0568 7.00547C15.2382 5.88287 14.032 5.30077 12.4379 5.17603C10.887 5.0513 9.20675 6.00761 8.60365 6.00761C7.95741 6.00761 6.49262 5.21761 5.32941 5.21761C2.91683 5.25919 0.375 7.04709 0.375 10.7475C0.375 11.8286 0.547327 12.9512 0.978146 14.1154C1.53821 15.6538 3.51997 19.3959 5.5879 19.3128C6.66494 19.3128 7.44041 18.5643 8.86212 18.5643C10.2407 18.5643 10.9301 19.3128 12.1363 19.3128C14.2473 19.3128 16.0568 15.9033 16.5738 14.3649C13.7734 13.076 13.9027 10.6228 13.9027 10.5397ZM11.4901 3.72078C12.6533 2.39027 12.5241 1.14291 12.5241 0.685547C11.4901 0.768704 10.2838 1.39238 9.59451 2.1408C8.81904 2.97237 8.3882 4.01184 8.47435 5.13446C9.59451 5.21761 10.6285 4.67709 11.4901 3.72078Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3,
    height: 18.75,
    fill: "white",
    transform: "translate(0.375 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.2e73844bbf5ae22f7d5bcc3d41100f3a.svg";
export { ForwardRef as ReactComponent };